import React from 'react';
import PropTypes from 'prop-types';

export const Profile = props => (
  <div>
    <pre>{JSON.stringify(props.auth._oktaAuth.tokenManager.get('idToken'), null, 2)}</pre>
    <pre>{JSON.stringify(props.auth._oktaAuth.tokenManager.get('accessToken'), null, 2)}</pre>
  </div>
);

Profile.propTypes = {
  auth: PropTypes.any,
};

export default Profile;



// WEBPACK FOOTER //
// ./src/app/components/Profile/index.js